module.exports = __webpack_public_path__ + "static/media/carousel-arrow-left.632c5d96.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/carousel-arrow-left.svg
// module id = 551
// module chunks = 0